module.exports = __webpack_public_path__ + "images/emoji/es.a71255d8224c6964646d.png";